
export class InvalidProjectPathError extends Error{}
export class CircularRefError extends Error{}
export class TimeoutError  extends Error{}